import { render, staticRenderFns } from "./EditarDetallePresupuesto.vue?vue&type=template&id=0e16d640&scoped=true"
import script from "./EditarDetallePresupuesto.vue?vue&type=script&lang=js"
export * from "./EditarDetallePresupuesto.vue?vue&type=script&lang=js"
import style0 from "./EditarDetallePresupuesto.vue?vue&type=style&index=0&id=0e16d640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e16d640",
  null
  
)

export default component.exports